import Table16 from '@carbon/icons-react/es/table/16';
import { Tooltip } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'components/atoms/button';
import { IconWrapper } from 'components/atoms/icon-shell/icon-shell';
import { Popover } from 'components/atoms/popover';
import { DropdownMenu, DropdownMenuProps } from './grid-column-menu';

export const ColumnListPopover = ({
  placement = 'bottomLeft',
  ...rest
}: DropdownMenuProps): JSX.Element => {
  return (
    <Popover
      content={<DropdownMenu {...rest} />}
      placement={placement}
      trigger={['click']}
    >
      <Tooltip
        title={<FormattedMessage id="projects.list.settings.edit" />}
        placement="top"
      >
        <Button
          icon={
            <IconWrapper>
              <Table16 style={{ transform: 'rotate(90deg)' }} />
            </IconWrapper>
          }
          type="text"
          size="small"
          data-cy="columns_reorder.dropdown.trigger"
        />
      </Tooltip>
    </Popover>
  );
};
